<template>
  <div class="search-box box-wrapper">
    <div v-if="!isV2" class="search-box__select box-item">
      <v-menu nudge-bottom="4" offset-y :disabled="disabled">
        <template v-slot:activator="{ on, attrs }">
          <div class="search-box__displayed-name" v-bind="attrs" v-on="on">
            <span class="search-box__name">{{
              activeSelectItem.displayedName
            }}</span>
          </div>
        </template>
        <v-list width="125" :tile="true" class="search-box__list">
          <v-list-item
            v-for="option in options"
            :key="option.id"
            :class="[
              'search-box__item',
              { 'active-item': option.id === activeSelectItemId },
            ]"
          >
            <v-list-item-title
              class="search-box__title"
              @click="activeSelectItemId = option.id"
              >{{ option.displayedName }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <div class="search-box__input box-item">
      <input
        v-model.trim="searchedText"
        type="text"
        :placeholder="activeSelectItem.placeholder"
        :disabled="disabled"
        @keyup.enter="search"
        @focus="onFocus"
      />
    </div>
    <div class="search-box__button box-item">
      <v-btn
        :loading="loading"
        dark
        icon
        class="search-box__btn"
        :disabled="disabled"
        @click="search"
      >
        <v-icon size="16" color="white">fas fa-search</v-icon>
      </v-btn>
    </div>
    <v-menu
      v-model="isOpenMenu"
      nudgeWidth="303"
      nudgeLeft="343"
      nudgeBottom="24"
      maxWidth="303"
      :disabled="disabled"
    >
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on"></div>
      </template>
      <v-list class="search-box__search-list-menu">
        <div class="search-box__menu-header px-3">
          <span class="search-box__menu-text">{{ menuHeaderText }}</span>
        </div>
        <template v-if="searchedCandidates.length">
          <div class="search-box__search-list scrollable">
            <div>
              <v-list-item
                v-for="item in searchedCandidates"
                :key="item.id"
                class="search-box__item d-flex flex-column"
                @click="openLink(item)"
              >
                <div
                  class="search-box__col col-avatar pl-1 pt-1 d-flex align-items-center"
                >
                  <Avatar
                    size="40px"
                    :name="item.candidate_name"
                    :profile="item.candidate_picture_url"
                    class="search-box__avatar"
                  />
                  <h5 class="search-box__candidate-name text-center">
                    {{ item.candidate_name }}
                  </h5>
                </div>
                <div class="search-box__col col-info pt-4">
                  <div class="lh-10 text-center mb-1">
                    <span class="search-box__job-title">{{
                      item.candidate_job_title
                    }}</span>
                  </div>
                  <div class="lh-10 text-center">
                    <span class="search-box__other"
                      >Project: {{ item.project_name }}</span
                    >
                  </div>
                  <div class="lh-10 text-center">
                    <span class="search-box__other"
                      >Status: {{ item.candidate_status }}</span
                    >
                  </div>
                </div>
              </v-list-item>
            </div>
          </div>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import Config from '@/js/config';
import { get } from '@/js/api/sourcer';
import { sleep } from '@/utils/';

export default {
  components: {
    Avatar: () => import('@/components/widgets/Avatar'),
  },

  props: {
    // hideSearchBox: {}
    disabled: Boolean,
  },

  data() {
    const options = [
      {
        id: 1,
        displayedName: 'Name',
        placeholder: 'John Smith',
        value: 'candidate_name',
      },
      {
        id: 2,
        displayedName: 'Email',
        placeholder: 'johnsmith@example.com',
        value: 'candidate_email',
      },
      {
        id: 3,
        displayedName: 'LinkedIn URL',
        placeholder: 'https://www.linkedin.com/in/johnsmith',
        value: 'candidate_linkedin_url',
      },
    ];

    return {
      options,
      activeSelectItemId: options[0].id,
      searchedText: '',
      searchedTextForDisplayInResult: '',
      searchedCandidates: [],
      isOpenMenu: false,
      loading: false,
    };
  },

  computed: {
    activeSelectItem() {
      return this.options.find((e) => e.id === this.activeSelectItemId) || {};
    },

    menuHeaderText() {
      return `${this.searchedCandidates.length} Search Results for ${this.searchedTextForDisplayInResult}`;
    },

    isV2() {
      return this.$store.getters['user/getIsUserV2'];
    },
  },

  created() {
    setTimeout(() => {
      // console.log(this.$attrs)
      // console.log(this.hideSearchBox in this.$props)
    }, 1000);
  },

  methods: {
    async search() {
      if (!this.searchedText || this.loading) return;

      try {
        this.loading = true;
        let response;
        if (this.isV2) {
          response = await get(
            `${Config.env.API_URL_V2}projects/candidates/search?search_query=${this.searchedText}`
          );
        } else {
          response = await get(
            `${Config.env.API_URL}candidates/search?${this.activeSelectItem.value}=${this.searchedText}`
          );
        }
        this.searchedCandidates = response.data;
        this.isOpenMenu = true;
        this.searchedTextForDisplayInResult = this.searchedText;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    onFocus() {
      if (this.searchedCandidates.length && this.searchedText !== '') {
        setTimeout(() => (this.isOpenMenu = true), 300);
      }
    },

    async openLink(candidate) {
      const query = {
        project: candidate.project_id,
        candidate: candidate.candidate_id,
        // 'app-tab': candidate.candidate_status === 'UNDER_REVIEW' ? 0 : 3
      };
      this.$router.push('/panel#').catch(() => {});
      await sleep(10);
      this.$router.push({ name: 'Panel', query }).catch(() => {});

      if (candidate.candidate_status !== 'UNDER_REVIEW') {
        this.$eventHub.$emit('open-history');
      }
      // this.$root.$refs.tabcompact.getPaging(candidate.candidate_id);
      await sleep(3000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.search-box__list {
  .search-box__item {
    min-height: unset;
    height: 25px;
    margin-bottom: 4px;
    cursor: pointer;

    &.active-item {
      background-color: #e6e7eb;
    }
    .search-box__title {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.38px;
      color: $gray-dark;
    }
  }
}

.search-box__search-list-menu {
  padding: 0 0 36px 0;

  .search-box__menu-header {
    padding-top: 8px;
    padding-bottom: 9px;
    border-bottom: 1px solid #d8d8d8;

    .search-box__menu-text {
      word-break: break-all;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.44px;
      color: $gray-light;
    }
  }
  .search-box__search-list {
    max-height: 424px;
    padding: 16px 12px 0;
    overflow-y: auto;

    .search-box__item {
      min-height: unset;
      padding: 6px 6px 12px;
      border: solid 1px #e6e7eb;
      border-radius: 4px;
      cursor: pointer;

      &:not(:last-child) {
        margin-bottom: 9px;
      }
      .search-box__candidate-name {
        margin: 0 0 5px 10px;
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 0.2px;
        color: #555555;
      }
      .search-box__col {
        &.col-info {
          flex-grow: 1;
          padding: 0 28px 0 15px;

          .lh-10 {
            line-height: 10px;
          }

          .search-box__job-title {
            display: inline-block;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: 0.28px;
            color: $gray-dark;
          }
          .search-box__other {
            display: inline-block;
            margin-bottom: 2px;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: 0.28px;
            color: $primary-dark;

            &.box-status {
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}

.search-box {
  display: flex;
  align-items: center;
  max-width: 343px;
  width: 100%;
  height: 40px;
  margin-right: 29px;
  border-radius: 4px;
  background-color: white;

  .box-item {
    height: inherit;
    border-radius: 0 4px 4px 0;
    overflow: hidden;
  }
  .search-box__select {
    flex: 0 0 125px;
    position: relative;
    overflow: visible;

    &::before {
      content: '';
      position: absolute;
      top: 4px;
      bottom: 0;
      right: 8px;
      width: 0;
      height: 0;
      margin: auto;
      border: 4px solid;
      border-color: $black transparent transparent transparent;
      pointer-events: none;
    }
    &::after {
      content: '';
      position: absolute;
      top: 7px;
      bottom: 7px;
      right: 0;
      margin: auto;
      width: 1px;
      background-color: #d8d8d8;
    }
    .search-box__displayed-name {
      width: 100%;
      height: inherit;
      padding: 6px 0 0 14px;

      .search-box__name {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 0.38px;
        color: $gray-dark;
        vertical-align: middle;
      }
    }
  }
  .search-box__input {
    flex: 1 1 auto;

    input {
      display: block;
      width: 100%;
      height: 100%;
      padding: 7px 10px 7px 7px;
      border: none;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.44px;
      color: $gray-dark;
      outline: none;

      &::placeholder {
        color: #c9c9c9;
      }
    }
  }
  .search-box__button {
    flex: 0 0 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $newAppBar;
    opacity: 0.8;

    .search-box__btn {
      width: 100%;
      height: 100%;

      &.v-btn::before {
        border-radius: 0;
      }
      &::v-deep .v-btn__loader {
        width: 15px;
        left: 12px;
      }
    }
  }
}
</style>
